import Vue from 'vue'
import axios from '@/api/axios.js'
import App from '@/App.vue'
import router from './router.js'
import store from '@/store'

import customMixin from '@/mixin/customMixin.js'

import './assets/css/custom.css'
import './assets/css/layout.css'
import './assets/css/grid.css'
import './assets/css/flex.css'
import './assets/css/layout.css'
import './assets/css/box-model.css'
import './assets/css/typography.css'
import './assets/css/width.css'
import './assets/css/height.css'
import './assets/css/z-index.css'
import './assets/css/background.css'
import './assets/css/border.css'

// disable console.log in production
if (process.env.NODE_ENV === 'production') {
	console.log = function() {}
}

Vue.config.productionTip = false

export const bus = new Vue()

Vue.mixin(customMixin)

const token = localStorage.getItem('token')
if (token) {
	axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
}

import axiosInterceptors from '@/api/axiosInterceptors.js'
axiosInterceptors()

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
